/** Public promo icons under portal/public/icons/promo. */
export function promoIconUrl(name: string): string {
  const base = String(import.meta.env.BASE_URL || '/').replace(/\/?$/, '/');
  return `${base}icons/promo/${name}`;
}

export const PROMO_ICONS = {
  gift3d: 'gift-3d.png',
  gift: 'gift.svg',
  computer: 'computer.svg',
  users: 'users.svg',
  users2: 'users2.svg',
  userAdd: 'user-add.svg',
  userFollowing: 'user-following.svg',
  tags: 'tags.svg',
  sparkles: 'sparkles.svg',
  calendar: 'calendar-lines.svg',
  copy: 'copy.svg',
  copy2: 'copy2.svg',
  copyUrl: 'copy-url.svg',
  edit: 'edit-text.svg',
} as const;
